<template>
  <div id="app" class="sl-shell">
    <div class="sl-texture"></div>

    <debug-panel v-if="config.ENV != 'production'"></debug-panel>

    <nav-bar></nav-bar>

    <div class="maincontent">
      <router-view></router-view>
    </div>

    <footer class="site-footer">
      <div class="site-footer__inner">
        <span class="site-footer__mark">SWIFTORLAND</span>
        <span class="site-footer__note">
          For legal, terms of service, privacy policy, or cookie policy
          <router-link to="/legal">click here</router-link>
        </span>
        <span class="site-footer__note">&copy; Copyright 2026 Swiftor, Inc.</span>
      </div>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'app',
  computed: {
    config () {
      return Vue.config
    }
  }
}
</script>

<style>
#app {
  font-family: var(--sl-font);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--sl-text);
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.link-footer a {
  color: #42b983;
}

.logo {
  text-decoration: none;
  color: black;
  font-size: 45px;
  font-weight: bold;
}

.user-cell {
  text-align: left;
}

.maincontent {
  position: relative;
  z-index: 1;
  flex: 1;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 28px 20px 64px;
  box-sizing: border-box;
}

/* --------------------------------------------------------------- footer */

.site-footer {
  position: relative;
  z-index: 1;
  border-top: 1px solid var(--sl-line);
  background: rgba(8, 8, 10, 0.6);
}

.site-footer__inner {
  max-width: 1240px;
  margin: 0 auto;
  padding: 26px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}

.site-footer__mark {
  font-family: var(--sl-font-display);
  font-size: 18px;
  letter-spacing: 1px;
  color: #4d4d57;
}

.site-footer__note {
  font-size: 13px;
  color: #6f6f79;
}

.site-footer__note a {
  color: var(--sl-link);
  text-decoration: none;
}

.site-footer__note a:hover {
  color: #ff8085;
}

/* kept so older markup that still says `.copyright` matches the footer type */
.copyright {
  font-size: 13px;
  color: #6f6f79;
}
</style>



// WEBPACK FOOTER //
// src/App.vue